import { Chip } from './chip';
import { Icon } from './icon';
import { Skeleton } from './skeleton';
import { useGetCase } from '../../api/queries/useGetCase';
import { CHIP_COLOURS } from '../lib/chip-colours';
import { cn } from '../lib/utils';

export function SubsetChip({ subsetId, className }: { subsetId: string; className?: string }) {
  const { data } = useGetCase(subsetId);
  if (!data || data?.isAllDocuments) return null;

  return (
    <Chip className={cn(CHIP_COLOURS.subset, 'border', className)}>
      <Icon className="lucide--group" />
      {data.name}
    </Chip>
  );
}
